import style from "./template-not-supported-modal.module.css";
import StyledButton, { ButtonStyle } from "frontend/ui-components/styled-button";
import { useEffect } from "react";
import tracking from "frontend/tracking";
import consts from "shared/consts";

export default function TemplateNotSupportedModal({
  onDismiss,
  createTemplateWithoutIntegrations,
  boardDocumentId,
}: {
  onDismiss: () => void;
  createTemplateWithoutIntegrations: () => void;
  boardDocumentId?: string;
}) {
  useEffect(() => {
    tracking.trackEvent(consts.TRACKING_CATEGORY.TEMPLATES, "synced-template-not-supported-shown", boardDocumentId);
  }, []);

  function renderCloseIcon() {
    return (
      <svg
        className={style.closeIcon}
        onClick={onDismiss}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="close-not-supported-template-modal"
      >
        <path
          d="M6.36407 6.36396L19.092 19.0919M19.092 6.36396L6.36407 19.0919"
          stroke="currentColor"
          strokeWidth="1.74"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <>
      <div className={style.container}>
        {renderCloseIcon()}
        <p className={style.title}>Create Synced template?</p>
        <div className={style.text}>
          <p>Your canvas template included sync items.</p>
          <p>For now, unfortunately, we don&apos;t support it.</p>
        </div>
        <div className={style.text}>What would you prefer?</div>
        <div className={style.buttonsContainer}>
          <StyledButton
            title="Create without synced items"
            onClick={() => {
              tracking.trackEvent(
                consts.TRACKING_CATEGORY.TEMPLATES, // category
                "create_template_without_synced_items", // action
                boardDocumentId
              );
              createTemplateWithoutIntegrations();
            }}
            customStyle={{ width: 240, height: 40 }}
          />
          <StyledButton
            title="Don׳t Create a template"
            onClick={() => {
              tracking.trackEvent(
                consts.TRACKING_CATEGORY.TEMPLATES, // category
                "cancel_create_temple_without_synced_items", // action
                boardDocumentId
              );
              onDismiss();
            }}
            style={ButtonStyle.outline}
            customStyle={{ width: 210, height: 40 }}
          />
        </div>
      </div>
    </>
  );
}
